import { FormConfig } from '../../../models/form-config';
import { OwnerDataConsts } from '../../../../core/consts/owner-data.consts';
import { FieldOption } from '../../../models/field-option';
import { PeselValidator } from '../../../validators/pesel.validator';
import { FormGroup } from '@angular/forms';
import { PeselService } from '../../../services/pesel.service';
import { addYearsToDate } from '../../../utils/time-utils';
import { getDrivingLicenseIssueYears } from '../../../utils/driving-license-years';
import {isNotNullOrUndefined} from 'codelyzer/util/isNotNullOrUndefined';

export class OwnerDataSectionConfig {

  static readonly START_YEAR = 1940;

  public previousPesel: string;

  public readonly consts = OwnerDataConsts;
  public config: FormConfig;
  private years: number[];

  getConfig(): FormConfig {
    return this.config;
  }

  public initDrivingLicenseIssueYears(pesel: string, config) {
    this.updateOptionsOnValidPesel(pesel, config);
  }

  public updateLicenseIssueYearOptions(items: number[], config: FormConfig) {
    if ( Object.keys(config.fieldsConfig).length === 0) {
      return;
    }
      // (<FieldOption>config.fieldsConfig.filter(({fieldKey}) => fieldKey === OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR)[0].options).items = items;
    if (isNotNullOrUndefined(config.fieldsConfig.find(({fieldKey}) => fieldKey === OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR))) {
      const minYear = items.length > 0 ? Math.min(...items) : null;
      const maxYear = items.length > 0 ? Math.max(...items) : null;
      const materialMinDate = minYear ? minYear + '' : null;
      const materialMaxDate = maxYear ? maxYear + '' : null;
      config.fieldsConfig.find(({fieldKey}) => fieldKey === OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR).materialDateFieldConfig.minDate = materialMinDate;
      config.fieldsConfig.find(({fieldKey}) => fieldKey === OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR).materialDateFieldConfig.maxDate = materialMaxDate;
    }
      // (<FieldOption>config.fieldsConfig.filter(({fieldKey}) => fieldKey === OwnerDataConsts.DRIVING_LICENSE_ISSUE_YEAR)[0]).materialDateFieldConfig.minDate = items;
  }

  public createConfig(config: FormConfig): FormConfig {
    this.config = config;
    return this.getConfig();
  }

  public resetAndSetPreviousPeselValue(value: string, formGroup: FormGroup): void {
    const result: any = PeselValidator(<any>{value});
    if (typeof result === 'boolean' && result) {
      this.resetPeselIfDifferent(formGroup);
      this.previousPesel = value;
    }
  }

  public updateOptionsOnValidPesel(value: string, config) {
    const result: any = PeselValidator(<any>{value});
    if (typeof result === 'boolean' && result) {
      const birthYear = PeselService.getBirthdate(value);
      const canMakeDrivingLicenseYear = addYearsToDate(16, birthYear);
      this.years = getDrivingLicenseIssueYears(canMakeDrivingLicenseYear.year());

      this.updateLicenseIssueYearOptions(this.years, config);
    }

    if (!value) {
      this.resetLicenseIssueYearOptions(config);
    }
  }

  private resetLicenseIssueYearOptions(config: FormConfig) {
    this.years = getDrivingLicenseIssueYears(OwnerDataSectionConfig.START_YEAR);
    this.updateLicenseIssueYearOptions(this.years, config)
  }

  private resetPeselIfDifferent(formGroup: FormGroup) {
    if (this.previousPesel !== formGroup.get(this.consts.PESEL).value && isNotNullOrUndefined(formGroup.get(this.consts.DRIVING_LICENSE_ISSUE_YEAR))) {
      if (this.years.indexOf(formGroup.get(this.consts.DRIVING_LICENSE_ISSUE_YEAR).value) === -1) {
        formGroup.get(this.consts.DRIVING_LICENSE_ISSUE_YEAR).reset();
      }
    }
  }
}
